import { useQuery, useLazyQuery, gql } from "@apollo/client"

const SCHEDULE_TRIGGER_FIELDS = gql`
  fragment ScheduleTriggerFields on ScheduleTrigger {
    id
    scheduleSource {
      schedules
      timeZone
      locations {
        id
        name
      }
    }
    targetType
    notifyUsersTarget {
      methods
      users {
        id
        fullName
      }
      groups {
        id
        name
      }
      output
    }
    notifyEmailsTarget {
      output
      emails
    }
    integrationTarget {
      id
    }
    pausedAt
    pausedBy {
      id
      firstName
      lastName
      fullName
      avatar {
        key
      }
    }
    author {
      id
      fullName
    }
    createdAt
    updatedAt
  }
`
const EVENT_TRIGGER_FIELDS = gql`
  fragment EventTriggerFields on EventTrigger {
    id
    eventSource {
      events
      locations {
        id
        name
      }
      process {
        id
        name
      }
      processStep
    }
    targetType
    notifyUsersTarget {
      methods
      users {
        id
        fullName
      }
      groups {
        id
        name
      }
      output
    }
    notifyEmailsTarget {
      output
      emails
    }
    integrationTarget {
      id
    }
    pausedAt
    pausedBy {
      id
      firstName
      lastName
      fullName
      avatar {
        key
      }
    }
    author {
      id
      fullName
    }
    createdAt
    updatedAt
  }
`

const TRIGGERS_QUERY = gql`
  ${SCHEDULE_TRIGGER_FIELDS}
  ${EVENT_TRIGGER_FIELDS}
  query Triggers {
    triggers {
      ... on ScheduleTrigger {
        ...ScheduleTriggerFields
      }
      ... on EventTrigger {
        ...EventTriggerFields
      }
    }
  }
`

const useQueryTriggers = (options) => useQuery(TRIGGERS_QUERY, options)

const useLazyQueryTriggers = (options) => useLazyQuery(TRIGGERS_QUERY, options)

export { useQueryTriggers, useLazyQueryTriggers, SCHEDULE_TRIGGER_FIELDS, EVENT_TRIGGER_FIELDS }
